module.exports = __webpack_public_path__ + "img/index-title.f1670e5f.png";